import {
  Award,
  BarChart3,
  ClipboardList,
  Crown,
  ListOrdered,
  Swords,
  Target,
  Trophy,
  Users,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  end?: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  { to: "/tippeles", label: "Csoportkör", icon: Target },
  { to: "/kieseses", label: "Kieséses", icon: Swords },
  { to: "/bajnoki-tipp", label: "Bajnoki tipp", icon: Crown },
  { to: "/tabella", label: "Tabella", icon: ListOrdered },
  { to: "/tippjeim", label: "Tippjeim", icon: ClipboardList },
  { to: "/kituzok", label: "Kitűzők", icon: Award },
  { to: "/statisztika", label: "Statisztika", icon: BarChart3 },
  { to: "/ligak", label: "Ligák", icon: Users },
  { to: "/archivum", label: "Archívum", icon: Trophy },
];
